export default __webpack_public_path__ + "static/media/money.509f4fe7.png";